function analyticsPath(url) {
  if (typeof url !== "string" || !url) return "/";
  try {
    return new URL(url, "https://www.digifist.com").pathname;
  } catch {
    return "/";
  }
}

function isThankYouPage(url) {
  return /^\/(?:en\/|nl-be\/|tr-tr\/)?thank-you\/?$/.test(analyticsPath(url));
}

module.exports = { analyticsPath, isThankYouPage };
